import { NavLink, useLocation, useParams } from 'react-router-dom';
import './CategoryTree.css';
import { chevron_right, Icon } from '../../Icon/Icon';
import { CategoryTreeContainer, TreeNode } from '../../../state/categories';
import { UrlParams } from '../../pages/CategoryPage';
import { ProductContainer } from '../../../state/product';
import { useTranslation } from '../../../i18n/i18n';
import { useConfig } from '../../../config';
import { ApiCategory } from '../../../types';

type CategoryProps = { item: TreeNode; perma: string; level: number; productPerma?: string };

export const Category = ({ item, perma, level, productPerma }: CategoryProps): JSX.Element => {
	const { pathname } = useLocation();
	const renderCollapsedPermas = ['/kampanjer/tork/handhygiene-komersiell', '/kampanjer/tork/handhygiene-restaurant'];
	const shouldRenderCollapsed = renderCollapsedPermas.includes(pathname);
	const { toggleNode, isOpen, getSupercategoryId } = CategoryTreeContainer.useContainer();
	if (item.children.length === 0) {
		return (
			<li>
				<NavLink
					to={'/' + item.perma}
					className={`navigation-item last-node ${productPerma === item.perma ? 'active' : ''}`}
				>
					<span>{item.name}</span>
				</NavLink>
			</li>
		);
	}

	const buttonClicked = (e: any, item: TreeNode) => {
		e.preventDefault();
		toggleNode(item);
	};

	let pill, chevron;
	if (item.parentId == 0) {
		pill = shouldRenderCollapsed ? (
			<span className="category-pill" />
		) : isOpen(item, perma) ? (
			''
		) : (
			<span className="category-pill" />
		);
	} else {
		chevron = (
			<button onClick={(e) => buttonClicked(e, item)}>
				<Icon
					shape={chevron_right}
					size={14}
					className={shouldRenderCollapsed ? 'collapsed' : isOpen(item, perma) ? 'expanded' : 'collapsed'}
				/>
			</button>
		);
	}
	const supercategoryId = getSupercategoryId(perma);
	let hasSubcategories = false;
	if (item.children.length > 0) {
		for (let i = 0; i < item.children.length; i++) {
			if (item.children[i].children.length > 0) {
				hasSubcategories = true;
				break;
			}
		}
	}

	return (
		<>
			<li
				className={
					'category-' +
					item.id +
					' category-level-' +
					level +
					(shouldRenderCollapsed ? ' collapsed' : isOpen(item, perma) ? ' expanded' : ' collapsed')
				}
			>
				<NavLink to={'/' + item.perma} className="navigation-item">
					{pill}
					<span>
						{chevron}
						{item.name}
					</span>
				</NavLink>

				<ul
					className={`subcategory ${
						!hasSubcategories ? 'last-category supercategory-' + supercategoryId : ''
					}`}
				>
					{shouldRenderCollapsed
						? null
						: isOpen(item, perma)
							? item.children
									.sort(function (a, b) {
										return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
									})
									.map((e) => (
										<Category
											key={e.id}
											item={e}
											perma={perma}
											level={level + 1}
											productPerma={productPerma}
										/>
									))
							: null}
				</ul>
			</li>
		</>
	);
};

export const CategoryTree = (): JSX.Element => {
	const { tree, getCategoryById } = CategoryTreeContainer.useContainer();
	const product = ProductContainer.useContainer();
	let { perma } = useParams<UrlParams>();
	const isProductPerma = /-p-/g.test(perma);
	const isCategoryPerma = /-c-/g.test(perma) || /^c\//g.test(perma);
	const urls = useTranslation().routes;
	const t = useTranslation().navigation;
	const config = useConfig();
	const { dirtyTree } = CategoryTreeContainer.useContainer();
	const kgnlCategorySort = [8114131, 8114132, 8114133, 8114135, 8114136, 8114137, 8114134, 8114138];
	const sortOverride = [
		1,
		3,
		5214200,
		5,
		6,
		4,
		2,
		8,
		8112475,
		8112023,
		8112025,
		8112024,
		8112797,
		8112363,
		8112813,
		8112439,
		8112435,
		8113164,
		8113165,
		8113166,
		8113167,
		8113168,
		8113169,
		8113309,
		8113170,
		...kgnlCategorySort,
	];

	if (isProductPerma) {
		// render category tree with current product's category perma
		perma = product.categoryPerma;
	} else if (!isCategoryPerma) {
		// set perma to first category perma in category tree to render first category open
		//perma = CategoryTreeContainer.useContainer().tree.children[0].perma;
		let category: ApiCategory | undefined;
		if ((category = getCategoryById(config.defaultCategory))) {
			perma = category.perma;
		}
	}

	return (
		<category-tree class={dirtyTree ? 'dirty' : ''}>
			<ul>
				{tree.children
					.sort((a, b) => {
						const aSort = sortOverride.indexOf(a.id);
						const bSort = sortOverride.indexOf(b.id);
						return aSort < bSort ? -1 : aSort > bSort ? 1 : 0;
					})
					.map((e) =>
						e.hide || (config.store === 'kgnl' && e.id === 8114138) ? null : (
							<Category
								key={e.id}
								item={e}
								perma={perma}
								level={0}
								productPerma={isProductPerma ? product.categoryPerma : ''}
							/>
						)
					)}

				{(config.store == 'kgse' || config.store == 'kgno') && (
					<li className="category-toner category-level-0 collapsed">
						<NavLink to={urls.printer} className="navigation-item last-node">
							<span className="category-pill"></span>
							<span>{t.inkAndToner}</span>
						</NavLink>
					</li>
				)}
			</ul>
		</category-tree>
	);
};
